import { SpotTile } from "@mlb/react-patterns/dist/components/SpotTag/spotTag.style";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import styled from "styled-components";
export var SelectFavoriteContainer = styled.div.withConfig({
  displayName: "styles__SelectFavoriteContainer",
  componentId: "sc-1stpo45-0"
})(["display:flex;flex-wrap:wrap;gap:8px 4px;", "{font-family:inherit;&:hover{background:", "0D;}&[data-focus-visible-added]{box-shadow:inset 0 0 0 3px rgba(0,137,255,0.65);outline:none;}}"], SpotTile, COLORS.mlbBlack);